import { Fragment, useEffect, useState, memo } from 'react'
import Cookies from "universal-cookie";
import { useSelector } from "react-redux";
import { Transition } from '@headlessui/react'
import { BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { EllipsisHorizontalIcon } from '@heroicons/react/20/solid'

import { fetchApi } from "../tools" // Consumir api

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

let filtrados = []
let runInitialFetch = true

 function Notificaciones({ setNotifica, notifica, dataNoti = [] }) {

    const [width, setWidth] = useState(window.screen.width)
    const [height, setHeight] = useState(window.screen.height)
    const [position, setPosition] = useState('')

    useEffect(() => {

        if (width > height) {
            setPosition('landscape')
        } else {
            setPosition('portrait')
        }
    }, [])

    const Carnet = useSelector(state => state.auth.Carnet)
    const IdEmp = useSelector(state => state.auth.IdEmp)

    const cookies = new Cookies()
    //const url = cookies.get('__urlSchoolApi') // url para enviar al api viene de cookies

    const urlState = useSelector(state => state.url.urlSchoolApi)
    const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState


    const { headersAPI: headers } = useSelector(state => state.url) // Headers para enviar al api viene de redux

    const [showTodas, setshowTodas] = useState(true)
    const [showCancelar, setshowCancelar] = useState(false)
    const [data, setData] = useState(dataNoti)

    useEffect(() => {
        if (runInitialFetch) {
            data.map(e => {
                filtrados.push({ Activo: e.Activo, Activo2: e.Activo2, Carnet: e.Carnet, Catalogo: e.Catalogo, Descripcion: e.Descripcion, FecDif: e.FecDif, Id: e.Id, SinLeer: e.SinLeer, Titulo: e.Titulo })
            })
        }
        runInitialFetch = false
    }, [runInitialFetch])

    const handleVerMas = (id) => {
        const upd_obj = filtrados.findIndex((obj => obj.Id === id));

        filtrados[upd_obj].Activo = !filtrados[upd_obj].Activo;

        if (showTodas) {
            setData(filtrados)
        } else {
            setData([...filtrados.filter(c => c.Activo2 === false)])
        }
    }

    const handleNoLeidas = () => {
        setData([...filtrados.filter(c => c.Activo2 === false)])
    }

    const handleTodas = () => {
        setData(filtrados)
    }

    const handleLeida = async (Id) => {
        const res = await fetchApi({
            method: 'POST',
            url: url + '/utils/notificaciones',
            headers,
            content: {
                Id,
                Carnet,
                HostName: "DEV1",
                IpHost: "131.107.1.235",
                IdEmp,
                NombreBrowser: "Windows"
            }
        })
        //console.log(res)

        const upd_obj = filtrados.findIndex((obj => obj.Id === Id));

        filtrados[upd_obj].Activo2 = true;

        if (showTodas) {
            setData(filtrados)
        } else {
            setData([...filtrados.filter(c => c.Activo2 === false)])
        }
    }

    return (
        <>
            <div aria-live="assertive" className="fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 overflow-y-auto scrollbar-hide lg:scrollbar-default sm:scrollbar-default">
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    <Transition
                        show={notifica}
                        as={Fragment}
                        enter="transform ease-out duration-300 transition"
                        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className={classNames(position === 'portrait' ? 'mt-10 w-[50%]' : 'mt-10 max-w-sm w-[100%]', 'py-2 px-2 bg-secundarioMira rounded-lg')}>
                            <div className="mt-2 w-full max-w-sm bg-secundarioMira">
                                <div className="flex">
                                    <div className="flex-1">
                                        <h1 className='text-white text-lg font-semibold'>Notificaciones</h1>
                                    </div>
                                    <div className="flex-2">
                                        <button
                                            onClick={() => setNotifica(!notifica)}
                                            type="button"
                                            className="rounded-full p-1 text-white focus:outline-none focus:ring-1 focus:ring-white"
                                        >
                                            <div className='px-2 bg-secundarioMira rounded-full p-1'>
                                                <span className="sr-only">Close notifications</span>
                                                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <div className="space-x-1">
                                    <button
                                        onClick={() => {
                                            setshowTodas(true)
                                            setshowCancelar(false)
                                            handleTodas()
                                        }}
                                        type="button"
                                        className={classNames(showTodas ? 'bg-gray-700' : 'bg-secundarioMira', 'relative inline-flex justify-center rounded-2xl border border-transparent py-2 px-4 text-base font-semibold text-blueNoti shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 transition duration-500 ease focus:outline-none sm:text-sm')}
                                    >
                                        Todas
                                    </button>
                                    <button
                                        onClick={() => {
                                            setshowTodas(false)
                                            setshowCancelar(true)
                                            handleNoLeidas()
                                        }}
                                        type="button"
                                        className={classNames(showCancelar ? 'bg-gray-700' : 'bg-secundarioMira', 'relative inline-flex justify-center rounded-2xl border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 transition duration-500 ease focus:outline-none sm:text-sm')}
                                    >
                                        No leídas
                                    </button>
                                </div>
                                {data.map((x) => (
                                    <div className="p-4" key={x.Id}>
                                        <div className="flex items-start">
                                            <button
                                                onClick={() => handleLeida(x.Id)}
                                                type="button"
                                                className="inline-flex w-full text-left rounded-md border border-transparent bg-secundarioMira px-2 py-2 text-base font-medium text-white shadow-sm hover:bg-primarioMira transition duration-500 ease focus:outline-none sm:text-sm"
                                            >
                                                <div className="flex-shrink-0">
                                                    <BellIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
                                                </div>
                                                <div className="ml-3 w-0 flex-1 pt-0.5">
                                                    <div className='flex flex-row'>
                                                        <div className='flex-1'>
                                                            <p className="text-sm font-medium text-white">{x.Titulo}</p>
                                                        </div>
                                                        <div className="flex-1">
                                                            <EllipsisHorizontalIcon onClick={() => handleVerMas(x.Id)} className="h-6 w-6 text-white" aria-hidden="true" />
                                                        </div>
                                                    </div>
                                                    <p className={classNames(x.Activo ? 'line-clamp-50' : 'line-clamp-2', 'mt-1 text-sm text-grisMira')}>{x.Descripcion}</p>
                                                    <div className='flex flex-row'>
                                                        <div className='flex-1'>
                                                            <span className={classNames(!x.Activo2 ? 'text-blueNoti' : 'text-grisMira', 'text-sm font-semibold')}>{x.FecDif}</span>
                                                        </div>
                                                        {!x.Activo2 &&
                                                            <div className='mt-1 flex-2'>
                                                                <svg viewBox="0 0 8 8" fill="currentColor"
                                                                    className="h-4 w-4 text-blueNoti">
                                                                    <circle cx="4" cy="4" r="3"></circle>
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>)
                                )}
                            </div>
                        </div>
                    </Transition>
                </div>
            </div >
        </>
    )
}

export default memo(Notificaciones)